<template>
  <div>
    <v-footer color="info" height="50"  app>
      <v-spacer />
      <span class="white--text">&copy; 2020 - <a style="color: white; text-decoration: none" href="https://andqxai.uz">AndQXAI </a></span>
      <v-spacer />
    </v-footer>
  </div>
</template>
<script>
export default {};
</script>